"use strict";

var root = document.documentElement,
    root_class = root.className;
root_class = root_class.replace('no-js', 'js');